import React, { useState, useEffect, useCallback, useRef } from 'react';
import { GoPlusCircle } from "react-icons/go";
import Transactionstable from './Transactionstable';
import SalesPlan from './SalesPlan';
import WalletTopup from './WalletTopup';
import CreateTicket from './CreateTicket';
import { useParams } from 'react-router-dom';
import { getWalletBalance } from '../services/Wallet/balance';
import SubAnchorTable from 'pages/SubAnchorTable';
import AddSubanchorModal from './AddSubanchorModal';

const InfoRow = ({ label, value }) => {
  return (
    <div className="mb-2 md:mb-4">
      <p className="text-sm md:text-base">{label}</p>
      <p className="font-semibold text-lg md:text-[20px]">₹{value?.toFixed(2)}</p>
    </div>
  );
};

const PartnerBalanceInfo = ({ walletId }) => {
  const [activeTab, setActiveTab] = useState('transactions');
  const [walletAmount, setWalletAmount] = useState(null);
  const [minimumAmount, setMinimumAmount] = useState(null);
  const [showAddSubanchorModal, setShowAddSubanchorModal] = useState(false);
  const [subAnchorRefreshKey, setSubAnchorRefreshKey] = useState(0);
  const { id } = useParams();
  const role = localStorage.getItem('authRole');
  const fetchInFlightRef = useRef(null);

  const fetchBalance = useCallback(async () => {
    try {
      const data = await getWalletBalance(walletId);
      setWalletAmount(data.amount);
      setMinimumAmount(data.minimum_amount);
    } catch (error) {
      console.error("Failed to fetch wallet info:", error);
    }
  }, [walletId]);

  useEffect(() => {
    if (!id || !walletId) return;
    const requestKey = `partner-balance-${walletId}`;
    if (fetchInFlightRef.current === requestKey) return;
    fetchInFlightRef.current = requestKey;
    fetchBalance().finally(() => {
      fetchInFlightRef.current = null;
    });
  }, [id, walletId, fetchBalance]);

  const renderActiveComponent = () => {
    switch (activeTab) {
      case 'salesPlan':
        return <SalesPlan className="my-4" />;
      case 'walletTopup':
        return <WalletTopup walletId={walletId} onTopupSuccess={fetchBalance} anchorType={'owner'} className="my-4" />;
      case 'createTicket':
        return <CreateTicket className="my-4" />;
      case 'subAnchor':
        return (
          <SubAnchorTable
            className="my-4"
            refreshTrigger={subAnchorRefreshKey}
          />
        );
      case 'transactions':
      default:
        return <Transactionstable className="my-4" walletId={walletId} />;
    }
  };

  return (
    <div className="bg-[#F3F4F6] rounded-md mx-4 my-4 p-4 flex flex-col gap-4">
      <div className="flex flex-col md:flex-row md:justify-between gap-4">
        <div className="flex flex-col md:flex-row gap-4">
          <InfoRow label="Wallet Balance" value={walletAmount ?? 0} />
          <InfoRow label="Minimum Balance" value={minimumAmount ?? 0} />
        </div>

        <div className="flex flex-wrap gap-3">
          <button
            className={`px-4 py-2 rounded font-medium 
    ${activeTab === 'transactions'
                ? "border-2 border-[#233B85] bg-[#F0F6FE] text-[#233B85]"
                : "bg-[#F0F6FE] text-[#233B85]"}`}
            onClick={() => setActiveTab('transactions')}
          >
            Transactions
          </button>

          {['finance_user', 'wallet_superadmin', 'wallet_finance'].includes(role) && <button
            className={`flex items-center gap-2 px-4 py-2 rounded font-medium
    ${activeTab === 'walletTopup'
                ? "border-2 border-[#233B85] bg-[#F0F6FE] text-[#233B85]"
                : "bg-[#F0F6FE] text-[#233B85]"}`}
            onClick={() => setActiveTab('walletTopup')}
          >
            <GoPlusCircle color="#233B85" /> Wallet Top-up
          </button>}

          
          {['finance_user', 'wallet_superadmin', 'wallet_finance'].includes(role) && (
            <>
              <button
                className={`px-4 py-2 rounded font-medium 
                  ${activeTab === 'subAnchor'
                    ? "border-2 border-[#233B85] bg-[#F0F6FE] text-[#233B85]"
                    : "bg-[#F0F6FE] text-[#233B85]"}`}
                onClick={() => setActiveTab('subAnchor')}
              >
                Sub anchors
              </button>
              {activeTab === 'subAnchor' && (
                <button
                  type="button"
                  className="flex items-center gap-2 px-4 py-2 rounded font-medium bg-[#233B85] text-white hover:bg-[#1e3370]"
                  onClick={() => setShowAddSubanchorModal(true)}
                >
                  <GoPlusCircle /> Add Subanchor
                </button>
              )}
            </>
          )}
          <button
            className={`px-4 py-2 rounded font-medium 
    ${activeTab === 'salesPlan'
                ? "border-2 border-[#233B85] bg-[#F0F6FE] text-[#233B85]"
                : "bg-[#F0F6FE] text-[#233B85]"}`}
            onClick={() => setActiveTab('salesPlan')}
          >
            Plans Available for Sale
          </button>





        </div>
      </div>

      <div>{renderActiveComponent()}</div>

      <AddSubanchorModal
        isOpen={showAddSubanchorModal}
        onClose={() => setShowAddSubanchorModal(false)}
        anchorId={id}
        onSuccess={() => setSubAnchorRefreshKey((k) => k + 1)}
      />
    </div>
  );
};

export default PartnerBalanceInfo;
